<script>
  import TileCoverPhotoDisplayIcon from './TileCoverPhotoDisplayIcon.svelte';

  export let group;
  export let mobile = false;
  export let editable = false;

  export let setPhotoDisplayType;

  $: coverPhotos = (group && group.cover_photos) || [];

  group.emoji = group.emoji || { outside_src: '/emojis/purple_star.png', name: 'star' };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .tile-cover-photos {
    height: 203px;
    width: 252px;
    overflow: hidden;

    .one-photo {
      width: 100%;
      height: 100%;
      object-fit: cover;

      img {
        border-radius: 12px;
      }
    }

    .two-photos {
      display: flex;
      gap: 1px;
      width: 100%;
      height: 100%;

      div {
        width: 50%;

        .two-photo {
          height: 100%;
          width: 100%;
          flex: 1;
          object-fit: cover;
        }

        .two-photo-1 {
          img {
            border-top-left-radius: 12px;
            border-bottom-left-radius: 12px;
          }
        }

        .two-photo-2 {
          img {
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
          }
        }
      }
    }

    .three-photos {
      display: flex;
      width: 100%;
      height: 100%;

      > div {
        width: 50%;
        margin-left: 1px;
      }

      > .three-photo-1-container {
        margin-left: 0px;
      }

      > div:last-child {
        display: flex;
        flex-direction: column;
        gap: 1px;
      }

      .three-photo {
        height: 100%;
        width: 100%;
        flex: 1;
        object-fit: cover;
      }

      .three-photo-1 {
        img {
          border-top-left-radius: 12px;
          border-bottom-left-radius: 12px;
        }
      }

      .three-photo-2 {
        img {
          border-top-right-radius: 12px;
        }
      }

      .three-photo-3 {
        img {
          border-bottom-right-radius: 12px;
        }
      }

      .three-photo-2,
      .three-photo-3 {
        height: 50%;
      }
    }
  }

  .cover-photo-wrapper:hover :global(.style-icon) {
    display: block;
  }

  .cover-photo-wrapper {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;

      &.contain {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        border: 1px solid $neutral-input-gray;
        object-fit: contain;
      }
    }
  }

  .mobile {
    height: 190px;
    width: 236px;
  }

  .tile-cover-photos-empty {
    background: #f9f7ff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
  }
</style>

<div class="tile-cover-photos" class:tile-cover-photos-empty={coverPhotos.length === 0} class:mobile={mobile}>
  {#if coverPhotos.length === 0}
    <img src={group.emoji.outside_src} alt="{group.emoji.name} emoji" style="width: 48px; height: 48px;" />
  {:else if coverPhotos.length === 1}
    <div class="cover-photo-wrapper one-photo">
      {#if editable}
        <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(0)} photo={coverPhotos[0]} />
      {/if}
      <img
        src={coverPhotos[0].url}
        class={coverPhotos[0].display_style || 'cover'}
        alt="{group.name} cover photo collage" />
    </div>
  {:else if coverPhotos.length === 2}
    <div class="two-photos">
      <div>
        <div class="cover-photo-wrapper two-photo two-photo-1">
          {#if editable}
            <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(0)} photo={coverPhotos[0]} />
          {/if}
          <img src={coverPhotos[0].url} class={coverPhotos[0].display_style || 'cover'} />
        </div>
      </div>
      <div>
        <div class="cover-photo-wrapper two-photo two-photo-2">
          {#if editable}
            <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(1)} photo={coverPhotos[1]} />
          {/if}
          <img
            src={coverPhotos[1].url}
            class={coverPhotos[1].display_style || 'cover'}
            alt="{group.name} cover photo collage" />
        </div>
      </div>
    </div>
  {:else if coverPhotos.length === 3}
    <div class="three-photos">
      <div class="three-photo-1-container">
        <div class="cover-photo-wrapper three-photo three-photo-1">
          {#if editable}
            <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(0)} photo={coverPhotos[0]} />
          {/if}
          <img
            src={coverPhotos[0].url}
            class={coverPhotos[0].display_style || 'cover'}
            alt="{group.name} cover photo collage" />
        </div>
      </div>
      <div>
        <div class="cover-photo-wrapper three-photo three-photo-2">
          {#if editable}
            <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(1)} photo={coverPhotos[1]} />
          {/if}
          <img
            src={coverPhotos[1].url}
            class={coverPhotos[1].display_style || 'cover'}
            alt="{group.name} cover photo collage" />
        </div>
        <div class="cover-photo-wrapper three-photo three-photo-3">
          {#if editable}
            <TileCoverPhotoDisplayIcon setPhotoDisplayType={() => setPhotoDisplayType(2)} photo={coverPhotos[2]} />
          {/if}
          <img
            src={coverPhotos[2].url}
            class={coverPhotos[2].display_style || 'cover'}
            alt="{group.name} cover photo collage" />
        </div>
      </div>
    </div>
  {/if}
</div>
